import { Action } from '@ngrx/store';
import { PossibleBarrierModel } from '../../models';

export const GET_BARRIERS = '[Barriers] Get';
export const GET_BARRIERS_SUCCESS = '[Barriers] Get Success';
export const GET_BARRIERS_FAILURE = '[Barriers] Get Failure';
export const ADD_BARRIER = '[Barriers] Add';


export class GetBarriers implements Action {
    readonly type = GET_BARRIERS;
}
export class GetBarriersSuccess implements Action {
    readonly type = GET_BARRIERS_SUCCESS;
    constructor(public barriers: PossibleBarrierModel[]) { }
}
export class GetBarriersFailure implements Action {
    readonly type = GET_BARRIERS_FAILURE;
    constructor(public error: any) { }
}
export class AddBarrier implements Action {
    readonly type = ADD_BARRIER;
    constructor(public lat: number, public lng: number) { }
}

export type All = GetBarriers | GetBarriersSuccess | GetBarriersFailure | AddBarrier;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/actions/barriers.actions.ts